module.exports = __webpack_public_path__ + "ico_message_encuesta.png";